import React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

interface NavigationProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const Navigation: React.FC<NavigationProps> = ({ value, onChange }) => (
  <BottomNavigation 
    value={value} 
    onChange={onChange} 
    showLabels
    sx={{ 
      width: '100%', 
      position: 'fixed', 
      bottom: 0, 
      left: 0, 
      right: 0,
      borderTop: '1px solid rgba(0, 0, 0, 0.12)'
    }}
  >
    <BottomNavigationAction label="Inicio" icon={<HomeIcon />} />
    <BottomNavigationAction label="Registrar" icon={<AddCircleIcon />} />
    <BottomNavigationAction label="Nutrición" icon={<RestaurantIcon />} />
    <BottomNavigationAction label="Perfil" icon={<AccountCircleIcon />} />
  </BottomNavigation>
);

export default Navigation; 